import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BaseApiService } from './base-api.service';
import { AdminLoginRequest, AdminLoginResponse, ApiResponse } from '../models/api.models';

@Injectable({
  providedIn: 'root'
})
export class AdminAuthService extends BaseApiService {
  private adminTokenSubject = new BehaviorSubject<string | null>(localStorage.getItem('adminToken'));
  public adminToken$ = this.adminTokenSubject.asObservable();

  constructor(http: HttpClient) {
    super(http);
  }

  /**
   * Admin giriş yapma
   */
  login(credentials: AdminLoginRequest): Observable<AdminLoginResponse> {
    return this.http.post<AdminLoginResponse>(`${this.adminBaseUrl}AdminAuth/Login`, credentials).pipe(
      tap(response => {
        if (response?.baseResponse?.success && response.token) {
          this.setAdminToken(response.token);
          this.setAdminEmail(credentials.Email);
        }
      })
    );
  }

  /**
   * Admin çıkış yapma
   */
  logout(): Observable<any> {
    return this.http.post<any>(`${this.adminBaseUrl}AdminAuth/Logout`, {}).pipe(
      tap(() => {
        this.clearAdminToken();
      })
    );
  }

  /**
   * Admin token'ı ayarla
   */
  private setAdminToken(token: string): void {
    localStorage.setItem('adminToken', token);
    this.adminTokenSubject.next(token);
  }

  setAdminEmail(email: string): void {
    localStorage.setItem('adminEmail', email);
  }

  getAdminEmail(): string | null {
    return localStorage.getItem('adminEmail');
  }

  /**
   * Admin token'ı temizle
   */
  private clearAdminToken(): void {
    localStorage.removeItem('adminToken');
    this.adminTokenSubject.next(null);
  }

  /**
   * Admin token'ı al
   */
  getAdminToken(): string | null {
    return localStorage.getItem('adminToken');
  }

  /**
   * Admin giriş yapmış mı kontrol et
   */
  isAdminLoggedIn(): boolean {
    return !!this.getAdminToken();
  }

  /**
   * Mevcut token'ı al
   */
  getCurrentToken(): string | null {
    return this.adminTokenSubject.value;
  }
}
